import { get, put } from "../api";
import { useQuery, useQueryClient } from "@tanstack/react-query";

function ContactForms() {
  const queryClient = useQueryClient();
  const { data, status } = useQuery({
    queryKey: ["contact"],
    queryFn: () => get("/contact"),
  });
  return (
    <div className="w-full border rounded-lg shadow-lg p-4">
      <span className="text-lg font-semibold pe-2">
        Submitted contact forms
      </span>
      {status === "success" && data.map((contact) => <div>{contact.name}</div>)}

      <div className="flex flex-col gap-2 pt-4">
        {data &&
          data.map((contact) => (
            <div
              className="border border-gray-200 rounded-md p-2"
              key={contact.contact_info_id}
            >
              <div className="flex justify-between">
                <div>
                  <div className="font-semibold">
                    {contact.first_name} {contact.last_name}
                  </div>
                  <div>{contact.email}</div>
                  <div>{contact.phone_number}</div>
                  <div>{contact.company}</div>
                  <div className="ps-4 text-sm">{contact.message}</div>
                </div>
                <div>
                  <button
                    className="bg-orange-500 px-2.5 py-1.5 rounded-md hover:bg-orange-300"
                    onClick={async () => {
                      await put(`/contact/hide/${contact.contact_info_id}`);
                      await queryClient.invalidateQueries(["contact"]);
                    }}
                  >
                    Hide Contact
                  </button>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default ContactForms;
